import axios from 'axios'
const moduleIndicator = {
  namespaced: true,
  state: () => {
    return {
      listIndicator: [],
      pagination: {},
      detailIndicator: {},
      isError: false,
      errMessage: ''
    }
  },
  mutations: {
    mutationIndicator (state, payload) {
      state.listIndicator = payload
    },
    setPagination (state, payload) {
      state.pagination = payload
    },
    setDetail (state, payload) {
      state.detailIndicator = payload
    },
    setIsError (state, payload) {
      state.isError = payload
    },
    setErrorMsg (state, payload) {
      state.errMessage = payload
    }
  },
  actions: {
    actionIndicator (context, data) {
      axios.get(`${context.rootState.setURL}/v1/indicator?page=${data.page}&name=${data.name}&limit=${data.limit}`,
        { headers: { token: context.rootState.auth.token } }).then((response) => {
        context.commit('mutationIndicator', response.data.data)
        context.commit('setPagination', response.data.pagination)
        context.commit('setIsError', false)
      }).catch(() => {
        context.commit('setIsError', true)
        context.commit('setErrorMsg', 'Data tidak ditemukan.')
      })
    },
    actionDetail (context, id) {
      axios.get(`${context.rootState.setURL}/v1/indicator/${id}`,
        { headers: { token: context.rootState.auth.token } }).then((response) => {
        context.commit('setDetail', response.data.data[0])
      }).catch(() => {})
    },
    actionInsert (context, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${context.rootState.setURL}/v1/indicator`, data, { headers: { token: context.rootState.auth.token } }).then((response) => {
          resolve(response.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    },
    actionEdit (context, data) {
      return new Promise((resolve, reject) => {
        axios.patch(`${context.rootState.setURL}/v1/indicator/${data.id}`, data,
          { headers: { token: context.rootState.auth.token } }).then((response) => {
          resolve(response.data)
        }).catch((err) => {
          reject(err.response.data.message)
        })
      })
    },
    actionDelete (context, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`${context.rootState.setURL}/v1/indicator/${id}`,
          { headers: { token: context.rootState.auth.token } }).then((response) => {
          resolve(response)
        }).catch(() => {})
      })
    }
  },
  getters: {
    getIndicator (state) {
      return state.listIndicator
    },
    getPaginationIndicator (state) {
      return state.pagination
    },
    getDetail (state) {
      return state.detailIndicator
    },
    isErrorIndicator (state) {
      return state.isError
    },
    errMessageIndicator (state) {
      return state.errMessage
    }
  }
}

export default moduleIndicator
